import { useEffect, useState } from "react";

function LogError({ text }) {

    const [log, setLog] = useState(null);

    useEffect(() => {
        setLog(text);
    }, [text]);

    return (
        <>
            {text !== null && log !== null && <div className="form_error text-center mt-15">{log}</div>}
        </>
    )
}

export default LogError;